import { Reveal } from "@/components/Reveal";
import { Check, X } from "lucide-react";

const IMG =
  "https://images.unsplash.com/photo-1558442086-8ea19a79cd4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxwcmltZSUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJhbCUyMGRlc2lnbnxlbnwwfHx8fDE3ODkxNTUxMjJ8MA&ixlib=rb-4.1.0&q=85";

const ISOLATED = [
  "Your own listings. Your own clients. Full stop.",
  "Off-market mandates stall quietly for months",
  "Buyers beyond your patch never find you",
];

const ALLIANCE = [
  "Every member agency's off-market book, within reach",
  "Qualified buyers and tenants you'd never reach alone",
  "Commission agreed in writing before introductions",
];

export const Audience = () => (
  <section id="network" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="font-eyebrow text-[11px] text-[#928E84]">Who it&rsquo;s for</p>
        <h2 className="font-display font-medium tracking-tight text-[#141518] text-4xl sm:text-5xl mt-5 max-w-3xl leading-[1.08]">
          Built for prime sales &amp; lettings agents who see the power of the network.
        </h2>
        <p className="text-base sm:text-lg text-[#635F57] leading-relaxed mt-6 max-w-2xl">
          Membership is limited to verified agents at prime and luxury
          residential agencies. The core benefit is simple: opportunities far
          beyond your own listings and client base — without ever touching a
          public portal.
        </p>
      </Reveal>

      <div className="mt-16 sm:mt-20 grid lg:grid-cols-12 gap-6">
        <Reveal className="lg:col-span-4">
          <div
            data-testid="audience-isolated-card"
            className="h-full bg-white border border-[#E7E4DC] rounded-3xl p-8 sm:p-10"
          >
            <p className="font-eyebrow text-[10px] text-[#928E84]">The isolated agent</p>
            <div className="mt-8 space-y-5">
              {ISOLATED.map((t) => (
                <div key={t} className="flex gap-3.5 items-start">
                  <X size={16} className="text-[#928E84] mt-1 shrink-0" strokeWidth={1.5} />
                  <p className="text-sm text-[#635F57] leading-relaxed">{t}</p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-5">
          <div
            data-testid="audience-alliance-card"
            className="h-full bg-[#141518] text-[#FAF9F5] rounded-3xl p-8 sm:p-10 relative overflow-hidden"
          >
            <p className="font-eyebrow text-[10px] text-[#B89B6C]">The PrimeConnect network</p>
            <div className="mt-8 space-y-5">
              {ALLIANCE.map((t) => (
                <div key={t} className="flex gap-3.5 items-start">
                  <Check size={16} className="text-[#D4C29E] mt-1 shrink-0" strokeWidth={1.5} />
                  <p className="text-sm text-[#FAF9F5]/75 leading-relaxed">{t}</p>
                </div>
              ))}
            </div>
            <p className="mt-10 pt-8 border-t border-[#FAF9F5]/10 font-display italic text-xl text-[#D4C29E]">
              &ldquo;The best listings never reach a portal. Now they reach you.&rdquo;
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.24} className="lg:col-span-3">
          <div className="h-full rounded-3xl overflow-hidden border border-[#E7E4DC] relative min-h-[320px]">
            <img
              src={IMG}
              alt="Prime residential interior"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#141518]/70 via-transparent to-transparent" />
            <p className="absolute bottom-6 left-6 right-6 font-display italic text-xl text-white">
              &ldquo;The deals you never see are the ones that matter.&rdquo;
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
